import { render } from "./CreatorModalSide.vue?vue&type=template&id=3c20e1b0"
import script from "./CreatorModalSide.vue?vue&type=script&lang=js"
export * from "./CreatorModalSide.vue?vue&type=script&lang=js"

import "./CreatorModalSide.vue?vue&type=style&index=0&id=3c20e1b0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__